import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

const CellLeave = ({ name, color }) => {
    if (!name) return null;
    return (
        <Container vAlign="center" hAlign="center" $bg={color}>
            <LeaveName content={name} />
        </Container>
    );
};

export default CellLeave;

const Container = styled(Flex)`
    border-radius: 6px;
    background: ${(props) => props.$bg};
    padding: 4px 8px;
    gap: 8px;
`;

const LeaveName = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;
